import "./MsActivationLinkExpired.css";
import { useConfig } from "../../contexts/ConfigContext";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";

function ActivationLinkExpired() {
  const { config } = useConfig();
  const bambora_url = config?.reportalLoginUrlMS1;
  return (
    <div className="activation-expired-root">
      <div className="activation-expired-content">
        <img src="/ciam/v1/static/images/ms/Broken_link.svg" alt="Broken" />
        <div>
          <h1 className="activation-expired-title">
            <Translate tKey={T_KEYS.MS.LINK_EXPIRED.TITLE} />
          </h1>

          <p className="activation-expired-text">
            <Translate tKey={T_KEYS.MS.LINK_EXPIRED.HEADER} />
            <a href={bambora_url} target="_blank" rel="noopener noreferrer">
              <Translate tKey={T_KEYS.MS.LINK_EXPIRED.REPORT.URL} />
            </a>
            <Translate tKey={T_KEYS.MS.LINK_EXPIRED.REPORT.TEXT} />
          </p>
        </div>

        <div className="activation-expired-footer">
          <img src="/ciam/v1/static/images/ms/Worldline-Mint-Horizontal.svg" alt="Worldline" />
        </div>
      </div>
    </div>
  );
}

export default ActivationLinkExpired;
